import type { ChangeEventHandler } from 'react';
import { Icon } from '@/components/atoms';
import styles from './SearchBar.module.css';

export interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  onSubmit?: () => void;
}

export function SearchBar({
  value,
  onChange,
  placeholder = 'Що шукаєш?',
  onSubmit,
}: SearchBarProps): JSX.Element {
  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => onChange(e.target.value);
  return (
    <form
      className={styles.bar}
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit?.();
      }}
      role="search"
    >
      <span className={styles.icon} aria-hidden>
        <Icon name="search" size={18} />
      </span>
      <input
        className={styles.input}
        type="search"
        value={value}
        placeholder={placeholder}
        onChange={handleChange}
        inputMode="search"
        autoCapitalize="off"
        autoCorrect="off"
      />
      {value ? (
        <button
          type="button"
          className={styles.clear}
          aria-label="Очистити"
          onClick={() => onChange('')}
        >
          ×
        </button>
      ) : null}
    </form>
  );
}
